// JavaScript Document
var menuPos =50
$(function(){
	var hasScrollHeader = $(".mainSite").find("#mainHeader").length > 0 || $(".mainSite").find("#mainPicker").length > 0;
	function updateHeaderState() {
		if($(window).scrollTop() > menuPos) {
			$("header").addClass("scrolled");
			if(hasScrollHeader) $("header").addClass("menuScrolled");
		}
		else {
			$("header").removeClass("scrolled");
			if(hasScrollHeader) $("header").removeClass("menuScrolled");
		}
	}
	if(hasScrollHeader) {
		updateHeaderState();
	} else {
		$("header").addClass("menuScrolled");
		updateHeaderState();
	}
	$(window).scroll(updateHeaderState);
});

// Menupicker
// $(function(){

//     const $picker  = $("#menuPicker");
//     const $slider  = $picker.find(".slider");
//     const $options = $picker.find(".option");

//     let $originalActive = $options.filter(".is-active");

//     if(!$originalActive.length){
//         $originalActive = $options.first().addClass("is-active");
//     }

//     function moveTo($el, instant=false){

//         const correction = parseFloat($picker.css("padding-left")) || 0;
//         const x = $el.position().left - correction;
//         const w = $el.outerWidth();

//         if(instant) $slider.css("transition","none");

//         $slider.css({
//             width: w,
//             transform: `translateX(${x}px)`
//         });

//         if(instant){
//             $slider[0].offsetHeight;
//             $slider.css("transition","");
//         }
//     }

//     // Init
//     moveTo($originalActive, true);

// 	// Fix: zet 'm nogmaals na render/fonts zodat breedtes/posities kloppen
// 	requestAnimationFrame(() => moveTo($options.filter(".is-active"), true));
// 	setTimeout(() => moveTo($options.filter(".is-active"), true), 0);

// 	// Optioneel (beste): opnieuw na laden van webfonts (italic/2e font)
// 	if (document.fonts && document.fonts.ready) {
// 	document.fonts.ready.then(() => moveTo($options.filter(".is-active"), true));
// 	}

//     // Hover → tijdelijk active verplaatsen
//     $options.on("mouseenter", function(){

//         $options.removeClass("is-active");

//         $(this).addClass("is-active");
//         moveTo($(this));
//     });

//     // Hover off → originele active terugzetten
//     $picker.on("mouseleave", function(){

//         $options.removeClass("is-active");

//         $originalActive.addClass("is-active");
//         moveTo($originalActive);
//     });

// });


// Einde menuPicker




// Amimatie zoom op header achtergrond
$(function() {
	$(".mainSite #mainHeader").css({'background-size':'107.5%'});	
	$(".mainSite #mainHeader .frame").css({'width':'107.5%', 'height':'107.5%'});				
})

 String.prototype.trim = function()
{ return this.replace(/(^\s+|(\s+$))/g,'');
}

$(document).on('show.bs.modal', '.modal', function () {
    var zIndex = 1040 + (10 * $('.modal:visible').length);
    $(this).css('z-index', zIndex);
    setTimeout(function() {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
    }, 0);
});

$(document).on('hidden.bs.modal', '.modal', function () {
    $('.modal:visible').length && $(document.body).addClass('modal-open');
});

var old = alert;

alert = function() {
  console.log(new Error().stack);
  old.apply(window, arguments);
};



function shorten(str) {
	var str = str
 	var short=str.split("</p>",2)			 
			 
	if (short(1).length > 80){
		return (short(1).substring(0,80)+"...");
	}
	else {
		return short(1)
	}				
};

// function amountInCart() {
// 	$.get("/modules/cart/ajax/cartAmount.asp", true, function(data) {
// 		$(".cartAmount.badge").text(data.items)
// 	}, "json")
// }



$(function() {

	// $(".topMenu").clone().prependTo(".mm-panels>#mm-1").addClass("mm-listview")
	// $(".mm-panels>#mm-1 .topMenu.mm-listview>li").addClass("mm-listitem")
	// $(".mm-panels>#mm-1 .topMenu.mm-listview>li>a").addClass("mm-listitem__text") 
				
	$("#contactForm").load("/modules/contact/formulier.asp") 
	// $("#aanmeldForm").load("/modules/bedrijven/aanmelden/formulier.asp") 
	// $("#eventForm").load("/modules/contact/evenement/formulier.asp") 

	// $("#inschrijfForm").load("/modules/contact/inschrijven.asp") 

	window.fitBgVideoFrames = function(scope) {
		let $scope = $(scope || document);
		let $iframes = $scope.is('iframe') ? $scope : ($scope.is('.frame') ? $scope.find('iframe') : $scope.find('.bgVideoElement .frame iframe'));

		$iframes.each(function() {
			let $iframe = $(this);
			let $frame = $iframe.closest('.frame');
			let frameWidth = $frame.outerWidth();
			let frameHeight = $frame.outerHeight();
			let videoRatio = 16 / 9;
			let frameRatio = frameWidth / frameHeight;

			if (!frameWidth || !frameHeight) return;

			if (frameRatio > videoRatio) {
				$iframe.css({
					width: frameWidth,
					height: frameWidth / videoRatio
				});
			} else {
				$iframe.css({
					width: frameHeight * videoRatio,
					height: frameHeight
				});
			}
		});
	}

	$('.bgVideoElement').each(function() {
		if (window.isManagedBackgroundMedia && window.isManagedBackgroundMedia(this)) return;
		let videoUrl = $(this).attr('data-video');
		if(videoUrl) {
			let $videoElement = $(this);
			let videoType = $videoElement.attr('data-video-type');
			let isLocalVideo = videoType === 'local' || /\.(mp4|webm|ogv|mov)(\?.*)?$/i.test(videoUrl);
			$(this).css('background-image', '');

			if (isLocalVideo) {
				$videoElement.append('<video class="bgVideoFile" muted loop autoplay playsinline webkit-playsinline preload="metadata" tabindex="-1" aria-hidden="true" src="'+videoUrl+'"></video>');
			} else {
				let videoId = videoUrl.split('/');
				videoId = videoId[videoId.length-1];
				let videoParams = videoUrl.indexOf('player.vimeo.com/video/') > -1 ? 'background=1&autoplay=1&loop=1&muted=1' : 'playlist='+videoId+'&controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1';
				$videoElement.append('<div class="frame" style="display:none;"><iframe src="'+videoUrl+'?'+videoParams+'" frameborder="0" onload="$(this).parent().fadeIn(); window.fitBgVideoFrames && window.fitBgVideoFrames(this.parentNode);" title="Video"></iframe></div>');
				window.fitBgVideoFrames($videoElement);
			}
		}
	})

	let bgVideoResizeTimeout;
	$(window).on('resize', function() {
		clearTimeout(bgVideoResizeTimeout);
		bgVideoResizeTimeout = setTimeout(function() {
			window.fitBgVideoFrames();
		}, 100);
	})
})

var keepAliveTeller= 0
var refreshRate = 5 //seconds


function setSession(sessionId,keepAlive)
{
	myDate=new Date
	myTime = myDate.getTime()
	$(".sessionFrame").remove()
	url='/login/includes/setSession.asp?key='+sessionId+'&time='+myTime

	$("body").append('<img class="sessionFrame" style="width:1px;height:1px" src="'+url+'">')
 if (keepAlive)
 {
	 keepAliveTeller++
	 setTimeout("setSession('"+sessionId+"',true)",(30000))
 }
 
}


function addStyleSheet(pad)
	{
		
		var headID = document.getElementsByTagName("head")[0];
		var cssNode = document.createElement('link');
		cssNode.type = 'text/css';cssNode.rel = 'stylesheet';
		cssNode.href = pad
		cssNode.media = 'screen'
		headID.appendChild(cssNode);

	}

				
	function addCmsButton(menu,icon,title,href)
		{
			if ($("#cmsBar #"+menu+ ' a[href="'+href+'"]').length == 0) {
				$("#cmsBar #"+menu).append('<li><a href="'+href+'"><i class="fa-regular '+icon+'"></i>'+title+'</a></li>')
			}
		//	document.getElementById("adminPaginaMenu").innerHTML=document.getElementById("adminPaginaMenu").innerHTML + '<li><a href="'+href+'"><img alt="" src="'+icon+'">'+title+'</a></li>'
			//alert(document.getElementById("taskBar").innerHTML)
		}



			
	function closeAjaxWindow(id)
		{
			document.documentElement.style.overflow=""		

			$("#transBg"+id).fadeOut("slow",function(){
				$("#transBg"+id).remove()
			})

		} 		



function openModal(modalId,url,qs)
{
	const prevModal = bootstrap.Modal.getInstance(document.getElementById(modalId))
	if(prevModal) {
		prevModal.hide();
		$('#'+modalId).remove();
	}

	$("body").append("<div class='modal fade' id='"+modalId+"' data-url='"+url+"' data-qs='"+qs+"' data-bs-focus='false' role='dialog'>  <div class='modal-dialog admin-modal'>    <div class='modal-content loadModal'></div></div></div>")
	
	const myModal = new bootstrap.Modal(document.getElementById(modalId), {
		keyboard: true
	})
	myModal.show();

	$("#"+modalId).load(url+"?myTime="+new Date().getTime()+"&"+qs);
}

function reloadModal(modalId)
{
	$modal=$("#"+modalId)
	var url=$modal.attr("data-url")
	var qs= $modal.attr("data-qs")
	$modal.load(url+"?myTime="+new Date().getTime()+"&"+qs)
}

function debounceRequest(func, wait) {
	let timeout;

	return function(...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
}


;(function($, win) {
	$.fn.inViewport = function(cb) {
	   return this.each(function(i,el){
		 function visPx(){
		   var H = $(this).height(),
			   r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
		   return cb.call(el, Math.max(0, t>0? H-t : (b<H?b:H)));  
		 } visPx();
		 $(win).on("resize scroll", visPx);
	   });
	};
  }(jQuery, window));



		
	// $(window).on('load resize scroll', function() {

	// 	$('.contentBlock').each(function() {
	// 		if ($(this).isInViewport()) {
	// 			$(this).addClass('animation')
	// 		}
	// 	})
	// });

// Offcanvas menu
$(function() {
	$('#offcanvasNavbar').on('show.bs.offcanvas', function () {
		
		// Visible toevoegen aan hoofdmenu. Check of er geen children zijn die visible zijn (ivm sluit en open)
		if ($(".offcanvas .offcanvas-body>ul:has(ul.visible)").length == 0) {
			$(".offcanvas .offcanvas-body>ul").addClass("visible")
		}

		// Chevrons toevoegen voor items met subpages
		$('.offcanvas ul li:has(ul)').each(function(){
			$(this).append("<span class='openSub fas fa-chevron-right'></span>")
		});
		
		// Submenu openen
		$('.offcanvas ul li:has(ul)>.openSub').on("click", function() {
			$(".offcanvas .offcanvas-body>ul").removeClass("visible")
			$(this).parent().parent().removeClass("visible")
			pageId = $(this).parent().attr("data-pageid")
			$("ul #menu"+pageId+"-0").addClass("visible")

			$(".offcanvas .offcanvas-body").animate({
				opacity: 0.25,
				marginLeft: "-100%",
				width: "100%"
			}, 350, function() {
				$(".offcanvas .offcanvas-body").css("margin","0")
				$(".offcanvas .offcanvas-body").animate({opacity: 1}, 150)
			});

			checkBackBtn()
			changeMenuTitle()
		})
	})
	
	// Terug in menu
	$('.offcanvas .offcanvas-header .btn-back').on("click", function() {
		current = $(".offcanvas li>ul.visible").attr("id")
		$("#"+current).parent().parent().addClass("visible")
		$("#"+current).removeClass("visible")

		$(".offcanvas .offcanvas-body").animate({
			opacity: 0.25,
			marginLeft: "100%",
			width: "100%"
		}, 350, function() {
			$(".offcanvas .offcanvas-body").css("margin","0")
			$(".offcanvas .offcanvas-body").animate({opacity: 1}, 150)
		});

		checkBackBtn()
		changeMenuTitle()
	})
	
	$('#offcanvasNavbar').on('hidden.bs.offcanvas', function () {
		$('.offcanvas ul li:has(ul) .openSub').remove();
	})
})

// Functie voor controleren of back button weergeven moet worden
function checkBackBtn() {
	console.log("aantal visible = "+$(".offcanvas .offcanvas-body>ul.visible").length)
	if ($(".offcanvas .offcanvas-body>ul.visible").length != 1) {
		$('.offcanvas .offcanvas-header .btn-back').css("visibility","visible")
	} else {
		$('.offcanvas .offcanvas-header .btn-back').css("visibility","hidden")
	}
}

// Menu titel veranderen aan de hand van de locatie in het menu
function changeMenuTitle() {
	if ($(".offcanvas li:has(ul.visible)").length > 0) {
		$(".offcanvas .offcanvas-header .offcanvas-title").text($(".offcanvas li:has(ul.visible)").last().find("a").attr("title"))
	} else {
		$(".offcanvas .offcanvas-header .offcanvas-title").text("Menu")
	}
}
// Einde Offcanvas menu


// Account offcanvas

$(document).on('show.bs.offcanvas', 'header .offcanvas', function () {
	$(".loginMenu .faIcon.temp").remove();
});

lastType = "";
function triggerAoc(type, returnUrl) {
	const offcanvasEl = document.querySelector('header .offcanvas');
	const offcanvasInstance = bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
	if (!offcanvasEl.classList.contains('show')) {
		offcanvasInstance.show();
	}

	if (type === lastType) {
		if ($(".account-offcanvas").hasClass("active")) {
			$(".account-offcanvas").removeClass("active");
		} else {
			$(".account-offcanvas").addClass("active");
			
			$(".account-offcanvas").removeClass(function(index, className) {
				return (className.match(/(^|\s)type-\S+/g) || []).join(' ');
			});
			$(".account-offcanvas").addClass("type-" + type);
		}
	} else if (type === "close") {
		$(".account-offcanvas").removeClass("active");
	} else {
		// console.log(lastType + " - " + type + "| ander item")
		if ($(".account-offcanvas").hasClass("active")) {
			// $(".account-offcanvas").removeClass("active");
		} else {
			$(".account-offcanvas").addClass("active");
		}

		$(".account-offcanvas").removeClass(function(index, className) {
			return (className.match(/(^|\s)type-\S+/g) || []).join(' ');
		});
		$(".account-offcanvas").addClass("type-" + type);
	}
	lastType = type;

	// Eerst alle bestaande fa-arrow-left iconen verwijderen uit de nav-items
	$(".loginMenu .nav-item .faIcon.temp").remove();

	if ($(".account-offcanvas").hasClass("active") && $(".account-offcanvas").hasClass("type-" + type)) {
		const navItem = $(".offcanvas .loginMenu .nav-item.type-" + type);

		// Voeg toe aan de pageTitle in de navitem (voor de span die in de pageTitle voorkomt)
		const pageTitle = navItem.find(".pageTitle");
		const span = pageTitle.find("span").first();
		if (span.length) {
			$('<i class="faIcon fa-sharp fa-light fa-arrow-left"></i>').insertBefore(span);
		} else {
			pageTitle.prepend('<i class="faIcon temp fa-sharp fa-light fa-arrow-left-long"></i>');
		}
	}

	// Juiste form ophalen
	loadAccountForm(type, returnUrl);
}

function loadAccountForm(type, returnUrl) {
	if (type === "login") {
		let forwardSubscriptions = $("#subscriptionForwardAfterLogin").val();
		let forwardSubscriptionsParam = forwardSubscriptions === "true" ? "&forwardSubscriptions=true" : "";
		$(".account-offcanvas .formHolder").load("/modules/accounts/ajax/frontLoginForm.asp?return=" + encodeURIComponent(returnUrl) + forwardSubscriptionsParam);
	} else if (type === "register") {
		$(".account-offcanvas .formHolder").load("/modules/accounts/ajax/frontLoginRegisterForm.asp?return=" + encodeURIComponent(returnUrl));
	} else if (type === "password") {
		let email = $(".account-offcanvas form input[type='email']").val();
		console.log("Emailadres uit currentForm:", email);
		$(".loginMenu .nav-item .faIcon.temp").remove();
		$(".account-offcanvas .formHolder").load("/modules/accounts/ajax/FrontLoginPasswordForm.asp?email=" + encodeURIComponent(email));
	}
}

function accountExtraQueryString(extraQueryString) {
	if (!extraQueryString) {
		return "";
	}

	extraQueryString = String(extraQueryString);
	if (extraQueryString.charAt(0) === "?") {
		extraQueryString = extraQueryString.substring(1);
	}
	if (extraQueryString.charAt(0) !== "&") {
		extraQueryString = "&" + extraQueryString;
	}

	return extraQueryString;
}

function registerFullModal(returnUrl, extraQueryString) {
	const modalUrl = "/modules/accounts/ajax/registerModal.asp?return=" + encodeURIComponent(returnUrl || "") + accountExtraQueryString(extraQueryString);

	$.get(modalUrl, function(data) {
		const existingModal = document.getElementById("registerFullModal");
		if (existingModal) {
			const existingInstance = bootstrap.Modal.getInstance(existingModal);
			if (existingInstance) {
				existingInstance.dispose();
			}
			existingModal.remove();
			$(".modal-backdrop").remove();
			$("body").removeClass("modal-open").css("overflow", "").css("padding-right", "");
		}

		$("body").append(data);
		const modalEl = document.getElementById("registerFullModal");
		const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
		modal.show();
	});
}

$(document).on('hide.bs.offcanvas', function () {
	$(".account-offcanvas").removeClass("active");
	$(".account-offcanvas").removeClass(function(index, className) {
		return (className.match(/(^|\s)type-\S+/g) || []).join(' ');
	});
});

// Einde Account offcanvas
